module.exports = __webpack_public_path__ + "img/1578590306.1db04005.jpg";